import type { ColliderDef } from './colliderTypes';

/**
 * Default colliders for the Mina scene.
 * Hollow cylinder acts as a scene boundary keeping the camera inside.
 * Fine-tune via dev tools Leva panel.
 */
export const MINA_DEFAULT_COLLIDERS: ColliderDef[] = [
  {
    id: 'mina-scene-boundary',
    type: 'cylinder',
    mode: 'hollow',
    enabled: true,
    blocksLineOfSight: false,
    "position": {
      "x": -0.7270479985411361,
      "y": -2.4564076612153865,
      "z": -1.0680078789918892
    },
    "radius": 5,
    "height": 28.990000000000006
  },
  {
    id: 'building',
    type: 'box',
    mode: 'solid',
    enabled: true,
    blocksLineOfSight: false,
    "position": {
      "x": -5.22986753752741,
      "y": -1.8729031327206709,
      "z": -4.05695643109756
    },
    "size": {
      "x": 36,
      "y": 19,
      "z": 4
    },
    "rotation": {
      "x": 0,
      "y": 0.5759586531581288,
      "z": 0
    }
  },
  // {
  //   id: 'mina-hill-part',
  //   type: 'box',
  //   mode: 'solid',
  //   enabled: true,
  //   "position": {
  //     "x": -0.43090753504008983,
  //     "y": -1.746592207684642,
  //     "z": 2.1032084484673748
  //   },
  //   "size": {
  //     "x": 7.25,
  //     "y": 0.3,
  //     "z": 2.4499999999999997
  //   },
  //   "rotation": {
  //     "x": 0,
  //     "y": 0.5934119456780721,
  //     "z": 0
  //   }
  // },

  {
    id: 'mina-hill-part',
    type: 'box',
    mode: 'solid',
    enabled: true,
    blocksLineOfSight: false,
    "position": {
      "x": -0.07068487092096953,
      "y": -4.541185153256894,
      "z": 3.404884699672243
    },
    "size": {
      "x": 15.5,
      "y": 6.5,
      "z": 7
    },
    "rotation": {
      "x": 0,
      "y": 0.5934119456780721,
      "z": 0
    }
  },
];
